import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { CostFileTemplate } from 'shared/types/roi-hub/fileIngestion.types';

export const GetCostFileTemplateById = new ReduxAsyncAction<'ROI_COST_FILE_TEMPLATE_BY_ID', string, CostFileTemplate>(
  'ROI_COST_FILE_TEMPLATE_BY_ID'
);

GetCostFileTemplateById.registerRequest(async (id: string) => {
  try {
    const { data } = await dash_api.get<CostFileTemplate>(`/v1/roi/cost-file-templates/${id}`);
    return data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred while retrieving cost file template', 'error');
    throw error;
  }
});

export const GET_COST_FILE_TEMPLATE_BY_ID_ACTION = GetCostFileTemplateById.actionNamespaceConstants;

export const getCostFileTemplateById = GetCostFileTemplateById.request;

export type GetCostFileTemplateByIdResponseAction = Action<typeof GET_COST_FILE_TEMPLATE_BY_ID_ACTION.response> & {
  data: CostFileTemplate;
};
